namespace Portico.Services {

	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import pmi = Portico.Models.Interfaces;
	import pms = Portico.Models.Setup;

	export interface IDataRowService {
		clean(dataTable: pms.DataTable, dataRow: pms.DataRow): void;
		create(dataTable: pms.DataTable): pms.DataRow;
		delete(dataRow: pms.DataRow, spinner?: string): angular.IPromise<boolean>;
		getByDataGroupId(dataGroupId: string, spinner?: string): angular.IPromise<pms.DataRow[]>;
		getConflict(dataRow: pms.DataRow, spinner?: string): angular.IPromise<pms.DataRow>;
		getHistory(id: string, spinner?: string): angular.IPromise<pms.DataRow[]>;
		save(dataRow: pms.DataRow, spinner?: string): angular.IPromise<pms.DataRow>;
    }

    @Service('app', 'dataRowService')
    @Inject('$q', 'apiService', 'storageService')
    export class DataRowService implements IDataRowService {
        constructor(
            private $q: angular.IQService,
            private apiService: IApiService,
            private storageService: IStorageService
        ) { }

		clean(dataTable: pms.DataTable, dataRow: pms.DataRow): void {
			if (dataTable && dataRow) {
				// remove invalid values
				for (let i = dataRow.dataValues.length - 1; i >= 0; i--) {
					const matches = dataTable.dataColumns.filter((dc: pms.DataColumn) => {
						return dc.id === dataRow.dataValues[i].dataColumnId;
					});

					if (!matches.length) {
						dataRow.dataValues[i].isDeleted = true;
						// this.dataRow.dataValues.splice(i, 1);
					}
				}

				// add missing values
				dataTable.dataColumns.forEach((dc: pms.DataColumn) => {
					if (dataRow.getDataValue(dc.id) === null) {
						dataRow.dataValues.push(new pms.DataValue({ id: null, dataRowId: dataRow.id, dataColumnId: dc.id, value: null, createdBy: null, createdOn: null, isDeleted: false }));
					}
				});
			}
		}

		create(dataTable: pms.DataTable): pms.DataRow {
			const dataRow = new pms.DataRow();

			dataRow.dataTableId = dataTable.id;

			this.clean(dataTable, dataRow);

			return dataRow;
		}

		delete(dataRow: pms.DataRow, spinner: string = null): angular.IPromise<boolean> {
            const endpoint = `/datarow/${dataRow.id}`;

			return this.apiService.deleteItem(endpoint, spinner).then((response: boolean) => {
                return response;
            });
        }

		getByDataGroupId(dataGroupId: string, spinner: string = null): angular.IPromise<pms.DataRow[]> {
            const endpoint = `/datarowbydatagroupid/${dataGroupId}`;

			return this.apiService.getItem<pms.DataRow[]>(endpoint, spinner).then((response: pms.DataRow[]) => {
                const dataRows: pms.DataRow[] = [];

                for (const dataRow of response) {
                    dataRows.push(new pms.DataRow(dataRow));
                }

                return dataRows;
            });
        }

		getConflict(dataRow: pms.DataRow, spinner: string = null): angular.IPromise<pms.DataRow> {
			const endpoint = `/datarowconflict`;

			return this.apiService.searchItem<pms.DataRow, pms.DataRow>(endpoint, dataRow, spinner).then((response: pms.IDataRow) => {
				return response ? new pms.DataRow(response) : null;
			});
		}

		getHistory(id: string, spinner: string = null): angular.IPromise<pms.DataRow[]> {
			const endpoint = `/datarowhistory/${id}`;

			return this.apiService.getItem<pms.DataRow[]>(endpoint, spinner).then((response: pms.DataRow[]) => {
				const dataRows: pms.DataRow[] = [];

				for (const dataRow of response) {
					dataRows.push(new pms.DataRow(dataRow));
				}

				return _.orderBy(dataRows, ['createdOn'], ['desc']);
			});
		}

		save(dataRow: pms.DataRow, spinner: string = null): angular.IPromise<pms.DataRow> {
			const endpoint = `/datarow`;

			return this.apiService.saveItem<pms.DataRow, pms.DataRow>(endpoint, dataRow, spinner).then((response: pms.IDataRow) => {
				return new pms.DataRow(response);
			});
		}
    }
}